// extracted by mini-css-extract-plugin
export default {"ContainerAlerts":"Alertes_ContainerAlerts__FIibe","ContainerAlerts__Sticky":"Alertes_ContainerAlerts__Sticky__enlTw"};